var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_vm._v("关联需求")]),_vm._v(" "),_c('div',[_c('el-tree',{attrs:{"data":_vm.data,"show-checkbox":"","node-key":"id","default-expanded-keys":[2, 3],"default-checked-keys":[5],"props":_vm.defaultProps}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b848c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/change-manage/RelatedRequirements.vue
// module id = null
// module chunks = 